const ContentLayoutStyle = {
    padding: "0 50px",
    minHeight: "calc(100vh - 134px)"
  }
  
  export default ContentLayoutStyle;